import { useMutation, useQuery, useQueryClient } from 'react-query';
import api from '@src/utils/api';

import { FETCH_CAMPAIGNS, GET_CAMPAIGNS } from '@src/constants/endpoints';

const fetchCampaigns = () => api.get(FETCH_CAMPAIGNS);

export const useFetchAllCampaigns = () =>
  useQuery([FETCH_CAMPAIGNS], fetchCampaigns, {
    select: (data) =>
      data?.map((d) => ({
        value: `${d?.id}`,
        label: d?.name,
        campaignLink: d?.campaignLink || null
      }))
  });

const fetchCampaignByLink = ({ queryKey }) => api.get(`${GET_CAMPAIGNS}/${queryKey[1]}`);
export const useFetchCampaignByLink = (campaignLink) =>
  useQuery([GET_CAMPAIGNS, campaignLink], fetchCampaignByLink, {
    enabled: !!campaignLink
  });

const updateCampaignFieldMapping = ({ campaignId, titleElementId, descriptionElementId }) =>
  api.patch(`${GET_CAMPAIGNS}/${campaignId}/field-mapping`, { titleElementId, descriptionElementId });

export const useUpdateCampaignFieldMapping = () => {
  const queryClient = useQueryClient();

  return useMutation(updateCampaignFieldMapping, {
    onSuccess: () => {
      queryClient.invalidateQueries([GET_CAMPAIGNS]);
    }
  });
};



// WEBPACK FOOTER //
// ./src/hooks/react-query/useCampaignData.js